<template>
  <div class="call-connection-point-select-container">
    <BSelect
      v-model="selectValue"
      :items="items"
      item-text="name"
      item-value="value"
      fit
    />
  </div>
</template>

<script setup lang="ts">
import { defineModel } from 'vue';
import { useI18n } from 'vue-i18n';
import useCallConnectionPoints from '@/composable/user/callResult/call-connection-points';

const VALUE_ALL = 'all';

const i18n = useI18n();

const selectValue = defineModel<string | null>({
  default: VALUE_ALL,
  get(value: string | null) {
    if (value == null) return VALUE_ALL;
    return value;
  },
  set(value: string | null) {
    if (value === VALUE_ALL) return null;
    return value;
  },
});
const { callConnectionPoints } = useCallConnectionPoints();
const items = [
  {
    value: VALUE_ALL,
    name: i18n.t('callResult.allConnectionPoints'),
  },
  ...callConnectionPoints,
];
</script>

<style lang="scss" scoped>
.call-connection-point-select-container {
  width: 100%;
}
</style>
